import http from '../http';
import Qs from 'qs';

// 课程报名统计-分页查询
const getEnrollStatisticsApi = (params) =>
  http
    .get('/theUserIdentity/dataStatistics/enrollStatistics', { params })
    .then((res) => res.data);

// const downloadDataStatisticsApi = (params, cancelToken) =>
//   http
//     .get('/theUserIdentity/dataStatistics/enrollStatisticsDataExport', {
//       params,
//       cancelToken,
//       responseType: 'blob'
//     })
//     .then((res) => res);
const downloadDataStatisticsApi = (params, cancelToken, onDownloadProgress) =>
  http
    .post(
      '/theUserIdentity/dataStatistics/enrollStatisticsDataExport',
      params,
      {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'blob',
        onDownloadProgress,
        cancelToken
      }
    )
    .then((res) => res);

// 运营端-课程报名班级汇总
const queryClassCoursePeriodStatisticPageApi = (params) =>
  http
    .post('/theUserIdentity/dataStatistics/queryClassCoursePeriodStatisticPage', params, {
      headers: { 'Content-Type': 'application/json' }
    })
    .then((res) => res.data);

const exportClassCoursePeriodStatisticPageApi = (params, cancelToken) =>
  http
    .post(
      '/theUserIdentity/dataStatistics/exportClassCoursePeriodStatisticPage',
      params,
      {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'blob',
        cancelToken
      }
    )
    .then((res) => res);
export default {
  getEnrollStatisticsApi,
  downloadDataStatisticsApi,
  queryClassCoursePeriodStatisticPageApi,
  exportClassCoursePeriodStatisticPageApi
};
